import styled from "styled-components";

export const StyledRadioGroup = styled.div``